import Raven from 'raven-js';
import ACBadRequestError from 'academy-common-lib/components/error/ACBadRequestError';
import ACMissingContentError from 'academy-common-lib/components/error/ACMissingContentError';
import ACForbiddenError from 'academy-common-lib/components/error/ACForbiddenError';
import ACRetiredContentError from 'academy-common-lib/components/error/ACRetiredContentError';
import { useEffect } from 'react';
import { ConditionalNavMarker } from '../../features/rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Checks if a LearningContentType is a publishable type that could have been retired.
 */
const isPublishableContentType = contentType => {
  if (!contentType) return false;
  return ['TRACK', 'COURSE', 'LESSON', 'SHORT_FORM_CONTENT'].includes(contentType);
};
/**
 * Converts potential Immutable Maps to plain objects
 */
const getPlainErrorObject = error => {
  var _toJS, _toJS2, _ref;
  return (_toJS = error === null || error === void 0 || (_toJS2 = (_ref = error).toJS) === null || _toJS2 === void 0 ? void 0 : _toJS2.call(_ref)) !== null && _toJS !== void 0 ? _toJS : error;
};
const getStatusFromHubError = error => {
  if (!error || typeof error === 'string') return null;
  const errorObj = getPlainErrorObject(error);
  return (errorObj === null || errorObj === void 0 ? void 0 : errorObj.status) || null;
};
const getStatusFromApolloError = error => {
  if (!error || typeof error === 'string') return null;
  const errorObj = getPlainErrorObject(error);
  if (errorObj.networkError && typeof errorObj.networkError === 'object' && 'status' in errorObj.networkError) {
    return errorObj.networkError.status || null;
  }
  return null;
};
const getErrorStatus = error => {
  var _ref2, _getStatusFromHubErro;
  return (_ref2 = (_getStatusFromHubErro = getStatusFromHubError(error)) !== null && _getStatusFromHubErro !== void 0 ? _getStatusFromHubErro : getStatusFromApolloError(error)) !== null && _ref2 !== void 0 ? _ref2 : 404;
};
const ApiError = ({
  error,
  marker404,
  marker403,
  markerDefault,
  resetLink,
  showLink = true,
  contentType
}) => {
  const status = getErrorStatus(error);
  useEffect(() => {
    if (![404, 403].includes(status)) {
      Raven.captureException(error);
    }
  }, [error, status]);
  switch (status) {
    case 404:
      {
        // For 404s on publishable content types, show retired content error
        if (isPublishableContentType(contentType)) {
          return /*#__PURE__*/_jsx(ConditionalNavMarker, {
            name: marker404,
            children: /*#__PURE__*/_jsx(ACRetiredContentError, {
              contentType: contentType
            })
          });
        }

        // For other 404s, show generic missing content error
        return /*#__PURE__*/_jsx(ConditionalNavMarker, {
          name: marker404,
          children: /*#__PURE__*/_jsx(ACMissingContentError, {
            showLink: showLink
          })
        });
      }
    case 403:
      return /*#__PURE__*/_jsx(ConditionalNavMarker, {
        name: marker403,
        children: /*#__PURE__*/_jsx(ACForbiddenError, {})
      });
    default:
      return /*#__PURE__*/_jsx(ConditionalNavMarker, {
        name: markerDefault,
        children: /*#__PURE__*/_jsx(ACBadRequestError, {
          to: resetLink
        })
      });
  }
};
export default ApiError;